const mountOrganizationParams = ({ organizationInputValue, filters }) => {
  const defaultParams = {
    minimal: true,
    perPage: 1000 * 1000,
  }

  if (!!organizationInputValue) {
    return {
      name: organizationInputValue,
      ...defaultParams,
    }
  }

  return {
    id: filters?.companyId,
    ...defaultParams,
  }
}

const instructionsText = ({ organizationInputValue }) => {
  return organizationInputValue.length < 3
    ? 'Digite no mínimo 3 letras pra buscar'
    : 'Sem opções'
}

const typeAndSearch = {
  mountOrganizationParams,
  instructionsText,
}

export default typeAndSearch
